import { PropsWithChildren } from 'react';

import {
  Auth0Provider,
  Auth0ProviderWithConfigOptions,
} from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

export const Auth0ProviderWithRedirectCallback: React.FC<
  PropsWithChildren<
    Pick<
      Auth0ProviderWithConfigOptions,
      'domain' | 'clientId' | 'authorizationParams'
    >
  >
> = ({ children, domain, clientId, authorizationParams }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    navigate(appState?.returnTo || '/');
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        ...authorizationParams,
        redirect_uri: globalThis.location.origin,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
